import { useState, useEffect, useContext } from 'react'
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { AppContext, AppContextProvider } from './context/context';
import GlobalStyles from './components/global_style';
import { baseUrl, client, domain, audience } from './config/delcare'
import Navbar from './layout/navbar';
import UiPopupSidebar from './components/ui_popup_sidebar';
import { Auth0Provider, useAuth0 } from '@auth0/auth0-react';
import ToastPopup from './components/toast_popup';
import TooltipDisposer from './components/tooltip_dispose';

const Index = () => {

    const {
        getAccessTokenSilently,
        loginWithRedirect,
        user,
        isAuthenticated,
        isLoading
    } = useAuth0();

    const {
        setLoginLoaded,
        getNeonUser,
        setToken,
        token,
        neonUser,
        setOffCanvas,
        getMarketPlace,
        toastInit, setToastInit,
        setToastContent,
        setKioskEnable,
        auth0VerifyEmail,
        getAllAdsProfileIds,
    } = useContext(AppContext)

    const { logout } = useAuth0()

    const [alreadyVerified, setAlreadyVerified] = useState(false)

    let authorize = async () => {
        // console.log("AUTHORIZING")
        try {
            let accessToken = await getAccessTokenSilently({
                authorizationParams: {
                    audience: audience
                }
            });
            let tokenData = { accessToken }
            setToken(old => tokenData)
            setKioskEnable(true)
            console.log("HAS TOKEN DATA")
            return tokenData
        }
        catch (err) {
            // console.log("ERROR AUTHORIZING", err)
            if (err?.error === 'consent_required' && isAuthenticated) {
                loginWithRedirect({
                    authorizationParams: {
                        audience: audience,
                        prompt: 'consent'
                    }
                })
                return false
            }
            if (err?.error == 'missing_refresh_token' && isAuthenticated) {
                logout({
                    clientId: client,
                    logoutParams: {
                        returnTo: window.location.origin
                    }
                })
            }
            setKioskEnable(false)
            return false
        }
        finally {
            setLoginLoaded(true)
        }
    }

    const initOffCanvas = () => {
        let el = document.querySelector("#offcanvasRight")
        if (el) setOffCanvas(new window.bootstrap.Offcanvas(el))
    }

    const initToaster = () => {
        let el = document.querySelector('.toast')
        let toast = new window.bootstrap.Toast(el, {
            animation: true,
            autohide: true,
            delay: 6000
        })
        setToastInit(toast)
    }

    useEffect(() => {
        if (!!user && !!token) {
            setToken({
                ...token,
                idTokenPayload: {
                    ...user
                }
            })
        }

        if (!!user && !!user.sub && !token) {
            authorize()
        }
    }, [user])

    useEffect(() => {
        try {
            if (!neonUser.user_id && token.accessToken) {
                getNeonUser(token?.idTokenPayload?.sub || user?.sub)
                return
            }
        }
        catch (err) {
            return
        }
    }, [token])

    useEffect(() => {
        if (neonUser && neonUser.stripe_customer_id && neonUser.role == "owner") {
            window.rewardful('ready', () => { })
        }

        if (!!neonUser.user_id && !alreadyVerified) {
            setAlreadyVerified(true)
            auth0VerifyEmail(neonUser.user_id)
            getAllAdsProfileIds(neonUser.agency_id)
            getMarketPlace()
        }
    }, [neonUser])

    useEffect(() => {
        if (isAuthenticated && !isLoading) {
            // console.log("AUTHENTICATION", { isAuthenticated, isLoading })
            authorize()
        }
        else setLoginLoaded(true)

    }, [isAuthenticated, isLoading])

    useEffect(() => {
        initOffCanvas()
        // authorize()
        initToaster()
    }, [])

    return (
        <div>
            <Navbar />
        </div>
    )
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Auth0Provider
        domain={domain}
        clientId={client}
        authorizationParams={{
            redirect_uri: window.location.origin,
            scope: "openid email profile",
            audience: audience
        }}
        useRefreshTokens={true}
        cacheLocation="localstorage"
        useRefreshTokensFallback={true}
    >
        <BrowserRouter>
            <AppContextProvider>
                <TooltipDisposer />
                <Index />
                <ToastPopup />
                <GlobalStyles />
                <UiPopupSidebar />
            </AppContextProvider>
        </BrowserRouter>
    </Auth0Provider>
);